module.exports = __webpack_public_path__ + "static/media/users.66abfccb.png";